import { Injectable } from '@angular/core';
import { Fine, FineDto } from '../../models/fine/fine.model';

@Injectable({
    providedIn: 'root',
})
export class MapperFineService {
    
    /** 
     * Map Data From API (DTO) to Logical Model (Fine) 
     */
    public mapFineFromDto(dto: FineDto): Fine {
        return {
            id: dto.Id || 0,
            name: dto.FineName || '',
            amount: dto.FineAmount || 0,
            isVatIncluded: dto.VatIncluded || false,
            revenueName: dto.RevenueCategory || '',
            site: dto.SiteName || ''
        };
    }

    /** 
     * Map Logical Model (Fine) back to API (DTO) 
     */
    public mapFineToDto(model: Fine): FineDto {
        return {
            Id: model.id,
            FineName: model.name,
            FineAmount: model.amount,
            VatIncluded: model.isVatIncluded,
            RevenueCategory: model.revenueName,
            SiteName: model.site
        };
    }
}
